<template>
  <div :class="wrapperClass">
    <!-- Top Counter -->
    <div v-if="counter && isTop" class="d-flex justify-content-between mb-1">
      <small v-if="isLeft">{{ currentLength }} / {{ max }}</small>
      <div></div>
      <small v-if="isRight">{{ currentLength }} / {{ max }}</small>
    </div>

    <!-- Textarea -->
    <textarea
        :class="classList"
        v-model="nativeModel"
        :maxlength="max"
        :disabled="disabled"
        :placeholder="placeholder"
        @input="handleInput"
    />

    <!-- Bottom Counter -->
    <div v-if="counter && isBottom" class="d-flex justify-content-between mt-1">
      <small v-if="isLeft">{{ currentLength }} / {{ max }}</small>
      <div></div>
      <small v-if="isRight">{{ currentLength }} / {{ max }}</small>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    max: Number,
    disabled: Boolean,
    counter: {
      type: Boolean,
      default: true,
    },
    counterPosition: {
      type: String,
      default: 'bottom-right', // 'top-left', 'top-right', 'bottom-left', 'bottom-right'
      validator: val =>
          ['top-left', 'top-right', 'bottom-left', 'bottom-right'].includes(val),
    },
    presetSize: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentLength: 0,
    };
  },
  computed: {
    nativeModel: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
    classList() {
      let base = 'textarea-base noMargin border-1';
      base += this.presetSize ? ' m-auto noPadding' : ' w-100 mx-0';
      return base;
    },
    wrapperClass() {
      return this.presetSize ? 'm-auto' : 'w-100';
    },
    normalizedCounterPosition() {
      const valid = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
      return valid.includes(this.counterPosition) ? this.counterPosition : 'bottom-right';
    },
    isTop() {
      return this.normalizedCounterPosition.startsWith('top');
    },
    isBottom() {
      return this.normalizedCounterPosition.startsWith('bottom');
    },
    isLeft() {
      return this.normalizedCounterPosition.endsWith('left');
    },
    isRight() {
      return this.normalizedCounterPosition.endsWith('right');
    },
  },
  mounted() {
    this.currentLength = this.modelValue?.toString().length || 0;
  },
  methods: {
    handleInput(event) {
      this.currentLength = event.target.value.length;
      this.$emit('update:modelValue', event.target.value);
    },
  },
};
</script>

<style scoped>
.textarea-base {
  display: block;
  width: 100%;
  padding: 10px 15px;
  resize: vertical;
  border-radius: 4px;
  box-sizing: border-box;
  min-height: 100px;
}
</style>
